import React from 'react'
import { Navbar } from '../../components/layout'
import { useScrollTo } from '../../hooks'
import {
    FinalCTASection,
    FooterSection,
    HeroSection,
    HowItWorksSection,
    PricingSection,
    ProofBarSection,
    TickerSection,
    WhoItsForSection,
} from './sections'

export default function Home() {
  const scrollTo = useScrollTo()

  // Mailchimp-style brand identity: light-only.
  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light')
    window.localStorage.setItem('nudge-theme', 'light')
  }, [])

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: '#FBE6D4', fontFamily: "'Manrope', sans-serif" }}
    >
      <Navbar onScrollTo={scrollTo} />

      <HeroSection />
      <TickerSection />
      <ProofBarSection />
      <HowItWorksSection />
      <WhoItsForSection />
      <PricingSection />
      <FinalCTASection />
      <FooterSection onScrollTo={scrollTo} />
    </div>
  )
}
